import { render } from "./PodcastView.vue?vue&type=template&id=fcb15700"
import script from "./PodcastView.vue?vue&type=script&lang=js"
export * from "./PodcastView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__